export const TRACK_REVIEW_CARD = {
  submittedOrder: '[Review Card] Submitted form to order new cards',
};
